import platform from "../../../util/platform";
const create = (trainingPlan) => {
    return (params) => {
        const path = `/content/training-plans/create`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, trainingPlan);
    };
};
const update = (trainingPlan) => {
    return (params) => {
        const path = `/content/training-plans/update`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, trainingPlan);
    };
};
const clone = (planId, newName) => {
    return (params) => {
        const path = `/content/training-plans/plan/${planId}/clone/${newName}`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, {});
    };
};
const deleteTrainingPlan = (trainingPlanId) => {
    return (params) => {
        const path = `/content/training-plans/plan/${trainingPlanId}/delete`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, {});
    };
};
const getAll = () => {
    return (params) => {
        const path = `/content/training-plans`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const get = (trainingPlanId) => {
    return (params) => {
        const path = `/content/training-plans/plan/${trainingPlanId}`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getForCohort = (cohortId) => {
    return (params) => {
        const path = `/content/training-plans/cohort/${cohortId}`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const enrollCohort = (planId, id) => {
    return (params) => {
        const path = `/content/training-plans/update/plan/${planId}/enroll/cohort/${id}`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, {});
    };
};
const unenrollCohort = (planId, id) => {
    return (params) => {
        const path = `/content/training-plans/update/plan/${planId}/unenroll/cohort/${id}`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, {});
    };
};
const enrollCohortGroup = (planId, id) => {
    return (params) => {
        const path = `/content/training-plans/update/plan/${planId}/enroll/cohort-group/${id}`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, {});
    };
};
const unenrollCohortGroup = (planId, id) => {
    return (params) => {
        const path = `/content/training-plans/update/plan/${planId}/unenroll/cohort-group/${id}`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, {});
    };
};
const enrollAccount = (planId, id) => {
    return (params) => {
        const path = `/content/training-plans/update/plan/${planId}/enroll/account/${id}`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, {});
    };
};
const unenrollAccount = (planId, id) => {
    return (params) => {
        const path = `/content/training-plans/update/plan/${planId}/unenroll/account/${id}`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, {});
    };
};
const trainingPlans = {
    create,
    update,
    clone,
    deleteTrainingPlan,
    getAll,
    get,
    getForCohort,
    enrollCohort,
    unenrollCohort,
    enrollCohortGroup,
    unenrollCohortGroup,
    enrollAccount,
    unenrollAccount,
};
export default trainingPlans;
